import { createSelector } from 'reselect';
import { TState } from 'store/index';

export const getState = createSelector(
  (state: TState) => state,
  (state) => state,
);
